module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Numbered Letters")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("R")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("P")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Letters on the news")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Political verbiage")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The meaning’s obtuse")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("1.0 to 50,000")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Not just numbers or statistics")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Every number had a dream")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Unmasked faces makes me silently scream")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("P.P.E.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Means to me?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Protection? Sure")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But more marks across my face")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And a nose so very sore")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("And while we drown in an avalanche of facts")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The milk of human kindness tastes sour")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The outlook dour")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I only hope we can recover")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1498627e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB9.vue
// module id = 84
// module chunks = 0